import { useEffect, useState } from 'react';

const useContainerWidth = (containerRef: React.RefObject<HTMLDivElement>) => {
  const [containerWidth, setContainerWidth] = useState<number>(0);

  useEffect(() => {
    if (containerRef?.current?.clientWidth) {
      const { clientWidth } = containerRef.current;
      setContainerWidth(clientWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef.current?.clientWidth]);

  return containerWidth;
};

export default useContainerWidth;
